module.exports = __webpack_public_path__ + "img/guzhang.edfe69e1.gif";